import { useEffect, useState } from 'react';

type extensionType = 'svg' | 'png' | 'jpg';
interface UseDynamicImageProps {
  name: string;
  fileType: extensionType;
}

const useDynamicImage = ({ name, fileType }: UseDynamicImageProps) => {
  const [image, setImage] = useState<string | null>(null);

  useEffect(() => {
    if (!name) return;
    const fetchImage = async (name: string) => {
      const response = await import(`../theme/assets/images/${name}.${fileType}`);
      setImage(response.default);
    };

    fetchImage(name)
      .then(() => console.log('loaded ', name))
      .catch(() => {
        console.log('failed to load ', name);
      });
  }, [name, fileType]);

  return image;
};

export default useDynamicImage;
